import { Component } from '@angular/core';
import { MENU_PAGE } from '../shared/defines/desktop.const';

@Component({
  selector: 'app-donation',
  templateUrl: './donation.component.html',
  styleUrls: ['./donation.component.scss']
})
export class DonationComponent {

  MENU_PAGE = MENU_PAGE;
}
